const Colours = {
  brand: '#2A90C6',
  accent: `#134481`,
}

export default Colours
